import palette from './palette';
import { Mixins } from '@mui/material/styles/createMixins';

declare module '@mui/material/styles/createMixins' {
  interface Mixins {
    appSvg: any;
  }
}

export enum SvgClass {
  disabled = 'svg-disabled',
  active = 'svg-active',
  expanded = 'svg-expanded',
}

export default {
  appSvg: {
    [`& svg.${SvgClass.disabled}`]: {
      color: palette.grey[300],
    },

    [`& svg.${SvgClass.active}`]: {
      color: palette.primary.main,
    },

    '& svg': {
      color: palette.grey[600],

      [`&:not(.${SvgClass.disabled}):hover`]: {
        cursor: 'pointer',
        color: palette.primary.main,
      },
    },
  },
};
